// @ts-ignore
// eslint-disable-next-line
const initYoutubePlayer = () => {
    const fullVideoBlock = document.querySelectorAll(
        '.section-fullscreen-video'
    );

    if (fullVideoBlock.length === 0) {
        return;
    }

    fullVideoBlock.forEach((videoBlock) => {
        const videoMobileBlock = videoBlock.querySelector(
            '.section-fullscreen-video__video-container'
        );
        const iframe = videoMobileBlock?.querySelector('iframe');
        const src = videoMobileBlock?.getAttribute('data-video');

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    if (iframe.getAttribute('src').length === 0) {
                        iframe.setAttribute('src', src);
                    }
                }
            });
        });

        observer.observe(videoMobileBlock);
    });
};

document.addEventListener('DOMContentLoaded', initYoutubePlayer);
